import Swiper from 'swiper';
import ScrollMagic from 'scrollmagic';

export default class Product {
    constructor() {

    }

    init() {
        //console.log("product initialised");
    }

    list() {
        //console.log("product list initialised");
    }

    detail() {
        this.initCarousel();
    }

    estore() {
        if(window.innerWidth > 500 ){
            let controller = new ScrollMagic.Controller({
                globalSceneOptions: {
                    triggerHook: 'onLeave'
                }
            });

            let pin = new ScrollMagic.Scene({
                triggerElement: '.filterBox',
                offset: -120
            }).setPin('.filterBox', {pushFollowers: false}).addTo(controller);
        }
    }

    finalize() {
        //console.log("product finalized");
    }

    initCarousel() {
        this.carousel =  new Swiper('#detailCarousel', {
            spaceBetween: 20,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
    }
}